import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class OfflineService {
    constructor() {}

    initializeApp() {}
    showSplashScreen() {}
    openPdf(byteArray: string) {}
    onOfflinePayment(initialPaymentId: number) {}
    reloadCurrentRoute() {}
}
